import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_LOCK_ICON } from '../../../../constants'
import { getFeatureFromCache } from '../../../../util/feature-cache'
import { LineItemLockedIcon as LineItemLockedIconUnified } from './LineItemLockedIcon'
import { LineItemLockedIconLegacy } from './LineItemLockedIconLegacy'
import type { LineItemLockedIconProps } from './useLineItemLockedIconModel'

export type { LineItemLockedTooltipVariant } from './useLineItemLockedIconModel'

export const LineItemLockedIcon: React.FC<LineItemLockedIconProps> = props => {
  const isUnifiedEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_LOCK_ICON
  )

  return isUnifiedEnabled ? (
    <LineItemLockedIconUnified {...props} />
  ) : (
    <LineItemLockedIconLegacy {...props} />
  )
}
